















import Vue from 'vue';
import { IProduct } from '../../../common/interfaces/products.interface';
import ProductSlider from '../../common/productslider/ProductSlider.vue';

export default Vue.extend({
  name: `BestSellersSection`,
  components: { ProductSlider },
  computed: {
    noArrowsClass(): string {
      if(this.products.length < 2) {
        return `no-arrows`;
      }
      if(this.products.length < 5) {
        return `no-arrows-desktop`;
      }
      return ``;
    },
  },
  props: {
    isPartner: {
      required: true,
      type: Boolean,
    },
    products: {
      required: true,
      type: Array as () => IProduct[],
    },
    shoppingAllowed: {
      default: true,
      type: Boolean,
    },
  },
});
